module.exports = __webpack_public_path__ + "media/images/badge-pretty-6c7c73f884b873c550ffb031fcbe1b82.svg";